import { useSelector } from 'react-redux';

export const useCheckRole = (portalId, accessKey) => {
    const authUser = useSelector((state) => state.auth?.value);
    const user = authUser?.Data;
    const userAccess = user?.UserAccess;
    if (!portalId || !accessKey) return false
    if (!userAccess || !userAccess.length) return false
    const roleAccess = userAccess.find(access => portalId == access.PortalId)
    if (!roleAccess || !roleAccess?.RoleAccess || !roleAccess.RoleAccess.length) return false
    const isAccess = roleAccess.RoleAccess.find(access => accessKey === access.AccessKey)
    if (!isAccess) return false
    return isAccess?.IsActive;
};
// export default ;

export const useCheckAdminRole = (accessKey) => {
    const authUser = useSelector((state) => state.auth?.value);
    const user = authUser?.Data;
    const userAccess = user?.UserAccess;
    let roleAccess ;
    if (!accessKey) return false
    if (!userAccess || !userAccess.length) return false
    if(userAccess.length ==1)
    roleAccess = userAccess[0];
    else {
        const AIRoleAccess = userAccess.find(access => access.PortalId === 1);
        const EARoleAccess = userAccess.find(access => access.PortalId === 2);
        const MarketerRoleAccess = userAccess.find(access => access.PortalId === 4);

        const AIRole = AIRoleAccess?.Role?.toLowerCase();
        const EARole = EARoleAccess?.Role?.toLowerCase();
        const MarketerRole = MarketerRoleAccess?.Role?.toLowerCase();

        if (AIRole === 'owner') {
            roleAccess = AIRoleAccess;
        } else if (EARole === 'owner') {
            roleAccess = EARoleAccess;
        } else if (MarketerRole === 'owner') {
            roleAccess = MarketerRoleAccess;
        } else if (AIRole === 'admin') {
            roleAccess = AIRoleAccess;
        } else if (EARole === 'admin') {
            roleAccess = EARoleAccess;
        } else if (MarketerRole === 'admin') {
            roleAccess = MarketerRoleAccess;
        } else {
            // fallback: assign the first available access as roleAccess
            roleAccess = AIRoleAccess || EARoleAccess || MarketerRoleAccess || userAccess[0];
        }
    }
    if (!roleAccess || !roleAccess?.RoleAccess || !roleAccess.RoleAccess.length) return false
    const isAccess = roleAccess.RoleAccess.find(access => accessKey === access.AccessKey)
    if (!isAccess) return false
    return isAccess?.IsActive;
};
// Resolves the logged-in user's currently active Marketer (Portal 4, "Switch Marketer" feature).
// Admin users are unaffected - they keep using their own dropdown-based marketer selection,
// so this hook returns null/[] for them rather than a value.
export const useActiveMarketerId = () => {
    const authUser = useSelector((state) => state.auth?.value);
    const activeMarketerId = useSelector((state) => state.auth?.activeMarketerId);
    const marketers = useSelector((state) => state.auth?.marketers);
    const userAccess = authUser?.Data?.UserAccess;
    const isAdmin = userAccess?.some(access => access.Role?.toLowerCase().includes('admin'));

    return {
        isAdmin,
        activeMarketerId: isAdmin ? null : (activeMarketerId ?? null),
        marketers: isAdmin ? [] : (marketers ?? []),
    };
};

export default {useCheckRole,useCheckAdminRole,useActiveMarketerId};